import { Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import { EarningsBoostGroup } from '../components';

interface EarningsBoostSectionProps {
  className?: string;
}

export const EarningsBoostSection = ({ className }: EarningsBoostSectionProps) => (
  <div className={twMerge('w-full px-4 bg-white', className)}>
    <div className="pb-[8px]! pt-[24px]!">
      <Typography variant="title18pxMed">나의 활동 관리</Typography>
    </div>
    <EarningsBoostGroup />
  </div>
);
